function getDocumentElement() {
    return window.document.documentElement;
}
function createAccessibilityService() {
    const html = getDocumentElement();
    const setContrastEnabled = (enabled = false) => {
        html.classList.toggle('t-high-contrast', enabled);
    };
    const setFontSize = (size = 100) => {
        html.style.fontSize = `${size}%`;
    };
    const toggleContrast = () => {
        html.classList.toggle('t-high-contrast');
    };
    const increaseFontSize = (fontSizeStep = 10, maxFontSize = 150) => {
        const newFontSize = Math.min(getFontSize() + fontSizeStep, maxFontSize);
        setFontSize(newFontSize);
    };
    const decreaseFontSize = (fontSizeStep = 10, minFontSize = 70) => {
        const newFontSize = Math.max(getFontSize() - fontSizeStep, minFontSize);
        setFontSize(newFontSize);
    };
    const getFontSize = () => {
        return Number.parseInt(html.style.fontSize || '100');
    };
    const isContrastEnabled = () => {
        return html.classList.contains('t-high-contrast');
    };
    const scrollToBottom = () => {
        window.scrollTo({ behavior: 'smooth', top: document.body.scrollHeight });
    };
    const scrollToTop = () => {
        window.scrollTo({ behavior: 'smooth', top: 0 });
    };
    return {
        decreaseFontSize,
        getFontSize,
        increaseFontSize,
        isContrastEnabled,
        scrollToBottom,
        scrollToTop,
        setContrastEnabled,
        setFontSize,
        toggleContrast,
    };
}
const AccessibilityService = createAccessibilityService();
export { AccessibilityService, };
//# sourceMappingURL=accessibility-service.js.map